








































































































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator'
import BaseDialog from '@/utils/dialog-control'
import $Api from '@api'
import { translate, DateTime } from '@/utils/filters'
import { finalize } from 'rxjs/operators'
import { Channel, Bank, Merchant, PaymentType, PaymentTypeScene } from '@/api/model/channel'
import { UtilsIndex } from '@/utils'

@Component
export default class LendingDialog extends BaseDialog {
    form: any = {
        bankId: '',
        channelId: '',
        bankCode: '',
        merchantId: '',
        status: '',
        noticeStatus: '',
        thridBankName: '',
        id: '',
        pri: '',
        // 同一优先级内按权重随机分流，0 表示该路由不参与分流。
        weight: 100,
        singleMax: '',
        singleMin: '',
        dayMax: '',
        monthMax: '',
        deductType: '',
        closeStartTime: '',
        closeEndTime: ''
    }
    banks: Bank[] = []
    channels: Channel[] = []
    merchs: Merchant[] = []
    paymentTypes: PaymentType[] = []
    rules = {
        channelId: { required: true, message: translate('channel.NoNull'), trigger: 'change' },
        bankId: { required: true, message: translate('bank.NoNull'), trigger: 'change' },
        noticeStatus: { required: true, message: translate('notice.StatusNoNull'), trigger: 'change' },
        status: { required: true, message: translate('notice.StatusNoNull'), trigger: 'change' },
        deductType: { required: true, message: translate('payType.NoNull'), trigger: 'change' },
        merchantId: { required: true, message: translate('merchant.StatusNoNull'), trigger: 'change' },
        pri: [
            { required: true, message: translate('pri.NoNull'), trigger: 'change' },
            { type: 'number', message: translate('notice.StatusNoNull'), trigger: 'change' }
        ],
        weight: [
            { required: true, message: translate('routing.weightRequired'), trigger: 'change' },
            { type: 'number', min: 0, message: translate('routing.weightInvalid'), trigger: 'change' }
        ]
    }
    loadBank = true
    date: string[] | null = []
    scene = PaymentTypeScene.Repayment

    async channelChange() {
        this.form.bankId = ''
    }

    formatMoney(money: string) {
        return UtilsIndex.clearNoNum(money)
    }

    @Watch('date', { immediate: true })
    onFormChanged(newVal: any) {
        if (this.date != null && this.date.length > 0) {
            if (!this.date[0] || !this.date[1]) return
            this.form.closeStartTime = this.getTime(this.date[0]).toString()
            this.form.closeEndTime = this.getTime(this.date[1]).toString()
        } else {
            this.form.closeStartTime = ''
            this.form.closeEndTime = ''
        }
    }

    @Watch('form.channelId')
    onChannelChanged(newVal: any) {
        this.loadBanks()
    }

    private getTime(startDate: any) {
        try {
            return (new Date(startDate.replace(new RegExp('-', 'gm'), '/'))).getTime()
        } catch (e) {
        }
        return ''
    }

    initDate() {
        this.date = null
        if (this.isEdit) {
            this.date = [DateTime(this.form.closeStartTime), DateTime(this.form.closeEndTime)]
        }
    }

    private loadBanks() {
        this.loadBank = true
        if (this.form.channelId === '') {
            return
        }
        $Api.routingService
            .queryBankListByChannelId(this.form.channelId)
            .pipe(
                finalize(() => {
                    this.loadBank = false
                })
            )
            .subscribe(data => {
                this.banks = data
                this.loadBank = false
            })
    }

    async loadData() {
        $Api.channelService.queryMerchantDropdownByUser().subscribe(data => {
            this.merchs = data
        })
        $Api.channelService.queryChannelDropdown().subscribe(data => {
            this.channels = data
        })
        $Api.channelService.queryPaymentTypeListByScene(this.scene).subscribe(data => {
            this.paymentTypes = data
        })
        this.loadBanks()
    }

    create() {
        return $Api.routingService.addDeDuct(this.form)
    }

    update() {
        return $Api.routingService.updateDeDuct(this.form)
    }

    onOpen() {
        // 历史路由及旧接口未返回权重时，按后端默认值参与分流。
        if (this.form.weight === '' || this.form.weight === null || this.form.weight === undefined) {
            this.form.weight = 100
        }
        this.loadData()
        this.initDate()
    }

    onClose() {

    }
}
